import React, { useState } from 'react';
import styled from 'styled-components';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { ArrowRight, Eye, EyeSlash } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

export const SignUpPage: React.FC = () => {
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [firstName, setFirstName] = useState<string>('');
  const [lastName, setLastName] = useState<string>('');
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [termsOfService, setTermsOfService] = useState<boolean>(false);
  const [privacyPolicy, setPrivacyPolicy] = useState<boolean>(false);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
    // Perform sign-up logic here
  };

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <AuthWrapper>
      <Container>
        <AuthCard>
          <AuthTitle>Create a new account</AuthTitle>
          <Form onSubmit={handleSubmit}>
            <Row className="mb-3">
              <Col>
                <Form.Group controlId="formFirstName">
                  <Form.Control
                    type="text"
                    placeholder="First Name"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group controlId="formLastName">
                  <Form.Control
                    type="text"
                    placeholder="Last Name"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Form.Group controlId="formBasicEmail" className="mb-3">
              <Form.Control
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="formBasicPassword" className="position-relative mb-3">
              <Form.Control
                type={showPassword ? 'text' : 'password'}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <PasswordToggleIcon onClick={toggleShowPassword}>
                {showPassword ? <EyeSlash /> : <Eye />}
              </PasswordToggleIcon>
            </Form.Group>
            <Form.Group controlId="formTermsOfService" className="mb-3">
              <Form.Check
                type="checkbox"
                label={
                  <>
                    I agree to the Source Coders{' '}
                    <AgreementLink to="/terms-of-service">Terms of Service</AgreementLink>
                  </>
                }
                checked={termsOfService}
                onChange={() => setTermsOfService(!termsOfService)}
              />
            </Form.Group>
            <Form.Group controlId="formPrivacyPolicy" className="mb-3">
              <Form.Check
                type="checkbox"
                label={
                  <>
                    I agree to the Source Coders{' '}
                    <AgreementLink to="/privacy-policy">Privacy Policy</AgreementLink>
                  </>
                }
                checked={privacyPolicy}
                onChange={() => setPrivacyPolicy(!privacyPolicy)}
              />
            </Form.Group>
            <SignUpButton variant="primary" type="submit" className="w-100 mb-3">
              Join Now <ArrowRight />
            </SignUpButton>
            <Divider>
              <DividerLine />
              <DividerText>Or</DividerText>
              <DividerLine />
            </Divider>
            <div className="d-flex justify-content-center">
                <GoogleSignUpButton>
                    <GoogleLogoCircle>
                    <img src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg" alt="Google Logo" width="20" />
                    </GoogleLogoCircle>
                    Sign Up with Google
                </GoogleSignUpButton>
            </div>
          </Form>
          <BottomText className="mb-3">
            Already have an account? <Link to="/login">Log In</Link>
          </BottomText>
        </AuthCard>
      </Container>
    </AuthWrapper>
  );
};

const AuthWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const AuthCard = styled.div`
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 40px;
  width: 100%;
  max-width: 600px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
`;

const AuthTitle = styled.h2`
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 40px;
    text-align: center;
`;

const GoogleSignUpButton = styled(Button)`
  font-weight: bold;  
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #007bff;
  color: white;
  margin-top: 20px;
`;

const GoogleLogoCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  margin-right: 8px;
`;

const PasswordToggleIcon = styled.span`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
`;

const SignUpButton = styled(Button)`
    font-weight: bold;
    background-color: #28a745;
    border-color: #28a745;
    color: white;

    &:hover,
    &:active,
    &:focus {
    background-color: #218838;
    border-color: #218838;
    color: white;
    }

    svg {
    font-weight: bold;
    }
`;

const BottomText = styled.p`
  margin-top: 40px;
  font-size: 0.9rem;

  a {
    font-weight: bold;
    color: #007bff;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const AgreementLink = styled(Link)`
  color: #6c757d;
  text-decoration: underline;

  &:hover {
    color: #6c757d;
    text-decoration: underline;
  }
`;

const Divider = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
`;

const DividerText = styled.span`
  background-color: white;
  padding: 0 10px;
  font-size: 0.9rem;
  color: #6c757d;
`;

const DividerLine = styled.div`
  background-color: #ccc;
  height: 1px;
  flex-grow: 1;
`;

